import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { Marchio } from 'my-lib-sanfelici';
import { Blobs } from 'my-lib-sanfelici';
import { MarchiService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-marchi-list',
  templateUrl: './marchi-list.component.html',
  styleUrls: ['./marchi-list.component.css']
})
export class MarchiListComponent implements OnInit {
    marchi: Observable<Marchio[]>;
blobs:Observable<Blobs[]>;
    constructor(
        private db:AngularFirestore,
        private marchiservice: MarchiService) { }
cancella(id){
    this.marchiservice.delete(id);
}
    ngOnInit() {
        this.marchi = this.marchiservice.list();
        this.blobs= this.db.
    collectionGroup<Blobs>('blobs', ref => ref.where('type', '==', 'marchi'))
.valueChanges();
    }

}
